import PropTypes from 'prop-types';
import React from 'react';
import ModalBase from '@molecules/ModalBase';
import { BodyLarge, H2 } from '@react/styledComponents';

const InfoModal = ({ bodyText, headingText, isOpen, onClose }) => {
    return (
        <ModalBase
            isOpen={isOpen}
            stylesBody={{
                paddingBottom: '64px',
                paddingLeft: '64px',
                paddingRight: '64px',
                paddingTop: '24px',
            }}
            onClose={onClose}
        >
            <H2>{headingText}</H2>
            <BodyLarge className="mt-1.875rem">{bodyText}</BodyLarge>
        </ModalBase>
    );
};

InfoModal.propTypes = {
    bodyText: PropTypes.string.isRequired,
    headingText: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default InfoModal;
